"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineTitle = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineConfigTitle_1 = require("./getOrderLineConfigTitle");
const getOrderLineTitle = (item) => {
    if (!item.versions)
        return null;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    if (!latest_version)
        return null;
    return (0, getOrderLineConfigTitle_1.getOrderLineConfigTitle)(latest_version.config, item.type);
};
exports.getOrderLineTitle = getOrderLineTitle;
